<template>
  <div class="out-wrap">
    <van-notice-bar
      left-icon="volume-o"
      mode="closeable"
      type="warning"
      v-if="isShowNotice"
      @close="closeNotice"
      text="评分标准：
          0-4分:基本不匹配且没展现；
          5-6分:刚好匹配且能有展现； 
          7-8分:基本匹配且较好展现;
          9-10分:完全匹配且优秀展现"
    />
    <Loadding ref="load" class="load-wrap" :submitInfo="`数据处理中...`" />
    <h5 class="top-title" :style="{ margin: isShowNotice ? '22px -20px 0 -20px' : '-20px -20px 0 -20px' }">
      弘策科技面试评估表
    </h5>
    <ul class="info-top">
      <li>
        <span class="tishi">姓名：</span><span>{{ (interviewerInfo && interviewerInfo.name) || '' }}</span>
      </li>
      <li>
        <span class="tishi">岗位：</span><span>{{ (interviewerInfo && interviewerInfo.position_sub_name) || '' }}</span>
      </li>
      <li>
        <span class="tishi">部门：</span><span>{{ (departmentInfo && departmentInfo.name) || '' }}</span>
      </li>
      <li>
        <span class="tishi">面试日期：</span><span>{{ interviewTime | dateFormatYMD }}</span>
      </li>
    </ul>
    <ul class="form-wrap">
      <li class="form-wrap-li">
        <h6>面试官评价</h6>
        <ul class="form-content-wrap" v-if="!isWatch">
          <li class="form-content-li" style="color:#4187F2;">
            <van-radio-group v-model="evaluationObj.isPass" direction="horizontal">
              <van-radio name="1" shape="square">面试通过</van-radio>
              <van-radio name="3" shape="square">待定（储备）</van-radio>
              <van-radio name="2" shape="square">面试不通过</van-radio>
            </van-radio-group>
            <van-field
              v-model="evaluationObj.content"
              rows="4"
              ref="input"
              label="面试评价"
              label-width="5em"
              clearable
              colon
              autosize
              type="textarea"
              placeholder="请输入评价内容"
              style="height:100%;background: #F5F5F5;padding-left:10px;margin-top: 10px;"
            />
            <div class="mianshiguan">
              <p>面试官：{{ evaluationObj.sign }}</p>
              <p>日期：{{ evaluationObj.time }}</p>
            </div>
          </li>
        </ul>
        <div v-else>
          <van-swipe v-if="isInterviewStaff" class="my-swipe" @change="swiperChange" :stop-propagation="false">
            <van-swipe-item
              v-for="(item, index) in dataInfo"
              :key="'content' + index"
              @click.native="swipeClickHandler(index, item)"
              :style="{ color: '#333' }"
            >
              <p>
                面试官：<span>{{
                  item.interview_staff_info
                    ? item.interview_staff_info.name + '-' + item.interview_staff_info.title
                    : '--'
                }}</span>
              </p>
              <p>
                面试轮次：<span>第 {{ index + 1 }} 轮</span>
              </p>
              <p>
                面试时间：<span>{{ item.interview_time | dateFormat }}</span>
              </p>
              <p>
                综合得分：<span
                  >{{ !item.feedback ? '暂无得分' : JSON.parse(item.feedback).pointData.total
                  }}{{
                    !item.feedback
                      ? ''
                      : JSON.parse(item.feedback).evaluationObj.isPass == '3' ||
                        JSON.parse(item.feedback).evaluationObj.isPass == '2'
                      ? '(默认评分)'
                      : ''
                  }}</span
                >
              </p>
              <p>
                面试结论：<span>{{
                  !item.feedback
                    ? '暂无结论'
                    : JSON.parse(item.feedback).evaluationObj.isPass == '1'
                    ? '通过'
                    : JSON.parse(item.feedback).evaluationObj.isPass == '2'
                    ? '不通过'
                    : '待定'
                }}</span
                ><em style="font-size: 12px;" v-show="item.feedback">（仅为本轮结果，非最终结果）</em>
              </p>
              <p>
                面试评价：<span>{{
                  !item.feedback
                    ? '暂无评价'
                    : JSON.parse(item.feedback).evaluationObj.content == ''
                    ? '暂无评价'
                    : JSON.parse(item.feedback).evaluationObj.content
                }}</span>
              </p>
            </van-swipe-item>
            <template #indicator>
              <div class="custom-indicator">
                <div class="custom-indicator-text" :class="{ 'custom-indicator-text-edit': isCanEdit }">
                  <van-icon v-if="isCanEdit" name="edit" />
                  <van-icon v-else name="eye-o" />
                  {{ isCanEdit ? '点击编辑' : '点击查看' }}
                </div>
                <div class="custom-indicator-index">{{ currentIndex + 1 }} / {{ dataInfo.length }}</div>
              </div>
            </template>
          </van-swipe>
          <p v-else>非当前人选的面试官，不展示相关信息</p>
        </div>
      </li>
      <li class="form-wrap-li" v-show="isInterviewPass" v-if="!isWatch">
        <h6>专业能力</h6>
        <ul class="form-content-wrap">
          <li class="form-content-li">
            <span>1、【知识/技能】过往经验匹配度：</span>
            <van-slider
              v-model="pointObj.professional_past"
              active-color="#4187F2"
              @input="getAllPoint"
              max="10"
              min="0"
              :step="1"
              drag-start="tishihandler"
            >
              <template #button>
                <div class="custom-button">{{ pointObj.professional_past | whitchProgress }}</div>
              </template>
            </van-slider>
          </li>
          <li class="form-content-li">
            <span>2、【知识/技能】专业知识、技能匹配程度：</span>
            <van-slider
              v-model="pointObj.professional_now"
              active-color="#4187F2"
              @input="getAllPoint"
              max="10"
              min="0"
              :step="1"
            >
              <template #button>
                <div class="custom-button">{{ pointObj.professional_now | whitchProgress }}</div>
              </template>
            </van-slider>
          </li>
          <li class="form-content-li">
            <span>3、【知识/技能】运用专业知识/过往经验完成本职工作：</span>
            <van-slider
              v-model="pointObj.professional_do"
              active-color="#4187F2"
              @input="getAllPoint"
              max="10"
              min="0"
              :step="1"
            >
              <template #button>
                <div class="custom-button">{{ pointObj.professional_do | whitchProgress }}</div>
              </template>
            </van-slider>
          </li>
        </ul>
      </li>
      <li class="form-wrap-li" v-show="isInterviewPass" v-if="!isWatch">
        <h6>综合素质</h6>
        <ul class="form-content-wrap">
          <li class="form-content-li">
            <span>4、【结果导向】问题解构（问题分析/解决方法）、成果交付、目标高强：</span>
            <van-slider
              v-model="pointObj.comprehensive_solve"
              active-color="#4187F2"
              @input="getAllPoint"
              max="10"
              min="0"
              :step="1"
            >
              <template #button>
                <div class="custom-button">{{ pointObj.comprehensive_solve | whitchProgress }}</div>
              </template>
            </van-slider>
          </li>
          <li class="form-content-li">
            <span>5、【沟通协作】沟通表达、团队协作、时间管理、服从意识：</span>
            <van-slider
              v-model="pointObj.comprehensive_communication"
              active-color="#4187F2"
              @input="getAllPoint"
              max="10"
              min="0"
              :step="1"
            >
              <template #button>
                <div class="custom-button">{{ pointObj.comprehensive_communication | whitchProgress }}</div>
              </template>
            </van-slider>
          </li>
          <li class="form-content-li">
            <span>6、【发展潜力】学习能力、创新能力、数据分析能力：</span>
            <van-slider
              v-model="pointObj.comprehensive_power"
              active-color="#4187F2"
              @input="getAllPoint"
              max="10"
              min="0"
              :step="1"
            >
              <template #button>
                <div class="custom-button">{{ pointObj.comprehensive_power | whitchProgress }}</div>
              </template>
            </van-slider>
          </li>
        </ul>
      </li>
      <li class="form-wrap-li" v-show="isInterviewPass" v-if="!isWatch">
        <h6>内驱力</h6>
        <ul class="form-content-wrap">
          <li class="form-content-li">
            <span>7、【个人特质】悟性高、有韧性、勤奋、务实、抗压、坚持（必须满足2项）：</span>
            <van-slider v-model="pointObj.trait" active-color="#4187F2" @input="getAllPoint" max="10" min="0" :step="1">
              <template #button>
                <div class="custom-button">{{ pointObj.trait | whitchProgress }}</div>
              </template>
            </van-slider>
          </li>
          <li class="form-content-li">
            <span>8、【动机/稳定性】离职原因、自身发展规划、对公司&岗位的意向：</span>
            <van-slider v-model="pointObj.power" active-color="#4187F2" @input="getAllPoint" max="10" min="0" :step="1">
              <template #button>
                <div class="custom-button">{{ pointObj.power | whitchProgress }}</div>
              </template>
            </van-slider>
          </li>
        </ul>
      </li>
      <li class="form-wrap-li" v-show="isInterviewPass" v-if="!isWatch">
        <h6>价值观</h6>
        <ul class="form-content-wrap">
          <li class="form-content-li">
            <span>9、【信德】诚实正直、言行一致、严于律己、德位相配：</span>
            <van-slider
              v-model="pointObj.true_power"
              active-color="#4187F2"
              @input="getAllPoint"
              max="10"
              min="0"
              :step="1"
            >
              <template #button>
                <div class="custom-button">{{ pointObj.true_power | whitchProgress }}</div>
              </template>
            </van-slider>
          </li>
          <li class="form-content-li">
            <span>10、【仁勇】互帮互助、共同进步、积极乐观、勇攀新高：</span>
            <van-slider
              v-model="pointObj.valiant"
              active-color="#4187F2"
              @input="getAllPoint"
              max="10"
              min="0"
              :step="1"
            >
              <template #button>
                <div class="custom-button">{{ pointObj.valiant | whitchProgress }}</div>
              </template>
            </van-slider>
          </li>
        </ul>
      </li>
      <li class="form-wrap-li" v-if="!isWatch" v-show="[2, 3].indexOf(Number(evaluationObj.isPass)) < 0">
        <h6>综合得分:</h6>
        <ul class="point-wrap">
          <li v-for="(item, index) in point" :key="index" class="point-li">
            <p>
              第{{ index + 1 }}轮面试：<span>{{ Number(item).toFixed(2) }}</span> 分
            </p>
          </li>
        </ul>
        <p class="all-point">
          整体平均得分：
          <span v-if="point.length == 0">0.00</span>
          <span v-else :style="{ color: isGood ? 'green' : 'red' }">
            {{ averageScore.toFixed(2) }}
          </span>
          分
        </p>
        <p class="warning" v-if="!isGood"><i>* </i>平均分低于70分。建议：面试不通过</p>
      </li>
    </ul>
    <div class="submit-btn-wrap">
      <van-button
        square
        class="submit-btn"
        :disabled="$route.query.from == 'check'"
        color="#4187F2"
        @click="nextStep"
        v-if="$route.query.type == 'edit'"
        >下一步</van-button
      >
      <van-button
        square
        :disabled="$route.query.from == 'check'"
        class="submit-btn"
        style="margin-top:10px;color: #4187F2;background: #fff;border: 1px solid #4187F2;"
        @click="returnBack"
        v-if="$route.query.type !== 'show'"
        >返回</van-button
      >
    </div>
    <van-dialog
      v-model="isShowWrap"
      title="面试官签名"
      confirmButtonText="提交"
      @confirm="submitEvalution"
      show-cancel-button
    >
      <canvas id="evaluationSignPad" ref="evaluationSign"></canvas>
      <div class="resign-btn-wrap">
        <van-button type="default" block size="small" @click="handleResign">重签</van-button>
      </div>
    </van-dialog>
  </div>
</template>

<script>
import { request } from '../../utils/request';
import API from '../../utils/API';
import { getStore, setStore } from '../../utils/localStore';
import Loadding from '../other/comp/load';
import _ from 'lodash';
import moment from 'moment';
import SignaturePad from 'signature_pad';
// import sign from "./signpage"
export default {
  name: 'evaluation',
  data() {
    return {
      pointObj: {
        professional_past: 5,
        professional_now: 5,
        professional_do: 5,
        comprehensive_solve: 5,
        comprehensive_communication: 5,
        comprehensive_power: 5,
        trait: 5,
        power: 5,
        true_power: 5,
        valiant: 5,
        total: 50,
      },
      isShowNotice: true,
      point: [],
      evaluationObj: {
        content: '',
        sign: '',
        time: moment()
          .locale('zh-cn')
          .format('YYYY-MM-DD'),
        isPass: '1',
      },
      defaultResult: null,
      isGood: true,
      dataInfo: [],
      currentIndex: 0,
      staff_id: '', //当前员工id
      interviewTime: '',
      isCanEdit: true,
      interviewerInfo: {},
      departmentInfo: {},
      isShowWrap: false,
      config: {
        penColor: 'rgb(0, 0, 0)', //笔刷颜色
        minWidth: 1, //最小宽度
        maxWidth: 2,
      },
      signaturePad: null,
      isInterviewStaff: null,
    };
  },
  components: {
    Loadding,
    // sign
  },
  computed: {
    isInterviewPass() {
      return [2, 3].indexOf(Number(this.evaluationObj.isPass)) < 0 ? true : false;
    },
    isWatch() {
      return this.$route.query.type == 'watch' ? true : false;
    },
    // 计算包含当前轮次的平均分
    averageScore() {
      if (this.point.length === 0) return 0;

      // 创建临时数组，包含当前轮次的分数
      let tempPoint = [...this.point];
      let currentRoundIndex = this.$route.query.index - 1;

      // 如果当前轮次索引有效，则包含当前轮次分数
      if (currentRoundIndex >= 0 && currentRoundIndex < tempPoint.length) {
        tempPoint[currentRoundIndex] = this.pointObj.total;
      }

      // 过滤掉0分，只计算有效分数
      let validPoints = tempPoint.filter((p) => p > 0);
      if (validPoints.length === 0) return 0;

      let sum = validPoints.reduce((tol, cur) => Number(tol) + Number(cur), 0);
      return sum / validPoints.length;
    },
  },
  filters: {
    whitchProgress(val) {
      let str = '';
      switch (val) {
        case 0:
        case 1:
        case 2:
        case 3:
        case 4:
          str = val + '分:不及格';
          return str;
        case 5:
        case 6:
          str = val + '分：及格';
          return str;
        case 7:
        case 8:
          str = val + '分：良好';
          return str;
        case 9:
        case 10:
          str = val + '分：优秀';
          return str;
      }
    },
  },
  watch: {
    $route: {
      handler(val, oval) {
        this.listenRouteChange(val.query);
      },
      immediate: true,
    },
  },
  methods: {
    init() {
      this.$nextTick(() => {
        if (this.signaturePad) {
          this.clearPad();
        } else {
          let canvas = document.getElementById('evaluationSignPad');
          this.resizeCanvas(canvas);
        }
      });
    },
    resizeCanvas(canvas) {
      let ratio = Math.max(window.devicePixelRatio || 1, 2);
      canvas.width = canvas.offsetWidth * ratio;
      canvas.height = canvas.offsetHeight * ratio;
      const ctx = canvas.getContext('2d');
      ctx.fillStyle = 'rgba(255, 255, 255, 0)';
      ctx.scale(ratio, ratio);
      this.signaturePad = new SignaturePad(canvas, this.config);
      this.clearPad();
    },
    clearPad() {
      this.signaturePad.clear();
    },
    defaultClick() {
      let signIsEmpty = this.signaturePad.isEmpty();
      if (signIsEmpty) {
        this.$toast({
          message: '请签名后提交！',
          duration: 2500,
        });
        return;
      }
      let signDataImg = this.signaturePad.toDataURL();
      this.$emit('sign-over', signDataImg);
    },
    nextStep() {
      if (!this.evaluationObj.content) {
        this.$toast('请填写面试评价');
        window.scrollTo(0, 0);
        this.$refs.input.focus();
        return;
      }
      this.$nextTick(() => {
        this.isShowWrap = true;
        this.init();
      });
    },
    addEvaluate(type, index, itemId) {
      this.$router.push({
        path: '/evaluation',
        query: { type, id: this.$route.query.id, index: index + 1, itemId },
      });
    },
    swipeClickHandler(index, row) {
      // console.log(row, 'row', index)
      // return
      if (row.interview_staff_id == this.staff_id) {
        let setDefaultData = {};
        //1、未评价  则使用上一轮（或上上轮）面试官的评价分数 ，如果往期都未评价，则使用默认评价
        if (row.feedback == '') {
          // for (let i = index - 1 <= 0 ? 0 : index - 1; i >= 0; i--) {
          //   let item = this.dataInfo[i]
          // console.log("没有评价",row)
          // do
          // {
          setDefaultData = { interview_time: row.interview_time };
          // setDefaultData.
          // }
          // while (item.feedback != '')
          // }
        } else {
          // 2、已经评价  则使用自己原由评价
          setDefaultData = row;
        }
        this.getAllPoint();
        setStore({
          name: 'evaluationData',
          content: setDefaultData,
          options: {
            expiry: '5h',
          },
        });
        this.addEvaluate('edit', index, row.id);
      } else {
        this.$toast({
          message: `非第${index + 1}轮面试官，不可操作`,
          duration: 3000,
          icon: 'clear',
        });
      }
    },
    swiperChange(index) {
      this.currentIndex = index;
      this.interviewTime = this.dataInfo[index].interview_time;
      this.isCanEdit = this.dataInfo[index].interview_staff_id == this.staff_id;
    },
    listenRouteChange(val) {
      if (val.type === 'edit') {
        this.isShowNotice = true;
        let evaluationData = getStore({ name: 'evaluationData' });
        if (!evaluationData) return;
        this.interviewTime = evaluationData.interview_time;
        this.initData(evaluationData.feedback);
      } else {
        this.isShowNotice = false;
      }
      this.getData(); //获取缓存信息
      this.getInfoData(val.id, val.type);
    },
    initData(data) {
      if (!!data) {
        let { pointData, evaluationObj } = JSON.parse(data);
        this.pointObj = pointData;
        this.evaluationObj = evaluationObj;

        // 如果有缓存数据，也需要同步当前分数状态
        this.$nextTick(() => {
          this.getAllPoint();
        });
      }
    },
    getInfoData(id, type) {
      this.dataInfo = [];
      //获取数据
      request({
        method: 'get',
        url: API.GET_INTERVIEW_INFO,
        data: {
          interview_id: id, //应聘者id
          staff_id: this.staff_id, //面试官id
        },
      }).then((res) => {
        this.dataInfo = res.data.data.logData;
        this.interviewerInfo = res.data.data.interviewInfo[0];
        this.departmentInfo = res.data.data.departmentInfo[0];
        this.judgeInterviewStaff(this.staff_id);
        if (type == 'watch') {
          this.interviewTime = this.dataInfo[0].interview_time;
        }
        this.isCanEdit = this.dataInfo[0].interview_staff_id == this.staff_id;

        // 初始化完成后，同步当前分数状态到页面
        this.$nextTick(() => {
          this.getAllPoint();
        });
      });
    },
    getData() {
      let userInfo = getStore({ name: 'evaluationUserInfo' });
      if (userInfo) {
        this.evaluationObj.sign = userInfo.name + '-' + userInfo.word;
        this.staff_id = ~~userInfo.staff_id;
      }
    },
    setData() {
      setStore({
        name: 'fillPointInfo',
        content: this.pointObj,
        options: {
          expiry: '2h',
        },
      });
      setStore({
        name: 'fillEvaluationInfo',
        content: this.evaluationObj,
        options: {
          expiry: '2h',
        },
      });
    },
    getAllPoint() {
      // 更新历史轮次得分数据
      this.point = [];
      _.map(this.dataInfo, (item) => {
        if (item.feedback != '') {
          let total = JSON.parse(item.feedback).pointData.total || 0;
          this.point.push(total);
        } else {
          this.point.push(0);
        }
      });

      // 计算当前轮次总分
      let tmpArr = Object.keys(this.pointObj);
      tmpArr = tmpArr.filter((item) => {
        return item != 'total';
      });
      let total = 0;
      _.map(tmpArr, (item) => {
        total += Number(this.pointObj[item]);
      });
      this.pointObj.total = total;

      // 更新当前轮次在point数组中的分数
      let currentRoundIndex = this.$route.query.index - 1;
      if (currentRoundIndex >= 0 && currentRoundIndex < this.point.length) {
        this.point[currentRoundIndex] = total;
      }

      // 根据计算出的平均分更新isGood状态
      this.updateIsGoodStatus();
    },
    updateIsGoodStatus() {
      // 根据平均分判断是否通过
      if (this.averageScore >= 70) {
        this.isGood = true;
      } else {
        this.isGood = false;
      }
    },
    closeNotice() {
      this.isShowNotice = false;
    },
    handleResign() {
      // 重签功能：清空画布
      if (this.signaturePad) {
        this.clearPad();
      }
    },
    submitEvalution() {
      let signIsEmpty = this.signaturePad.isEmpty();
      let signDataImg = '';
      if (signIsEmpty) {
        this.$toast.fail({
          message: `请签名后提交`,
          duration: 2500,
        });
        return;
      } else {
        signDataImg = this.signaturePad.toDataURL();
      }
      this.$refs.load.openLoad();
      let submitObj = {
        id: this.$route.query.itemId,
        interview_id: this.$route.query.id,
        url: window.location.href,
        staff_id: this.staff_id.toString().padStart(4, '0'),
        dataObj: JSON.stringify(
          Object.assign(
            {},
            {
              pointData: this.pointObj,
            },
            {
              evaluationObj: this.evaluationObj,
            }
          )
        ),
        signdata: signDataImg,
      };
      // console.log(this.pointObj,this.evaluationObj )
      // return
      request({
        method: 'post',
        url: API.POST_EVALUATION_DATA,
        data: submitObj,
      })
        .then((res) => {
          this.$refs.load.closeLoad();
          this.$toast.success({
            message: '保存成功',
            onClose: () => {
              this.returnBack();
            },
          });
        })
        .finally(() => {
          this.$refs.load.closeLoad();
        });
    },
    returnBack() {
      let url = window.location.href;
      if (url.indexOf('watch') >= 0) {
        this.$router.push({
          path: '/interviewEvaluation',
          query: {
            id: this.$route.query.id,
          },
        });
      } else {
        let tourl = url.replace(/edit/g, 'watch');
        window.open(tourl, '_self');
      }
    },
    judgeInterviewStaff(staff_id) {
      let res = _.find(this.dataInfo, (item) => item.interview_staff_id == staff_id);
      this.isInterviewStaff = res ? true : false;
    },
  },
};
</script>

<style lang="less" scoped>
@import '../../assets/css/page.css';
@import '../../assets/css/wrap.css';
.van-notice-bar {
  position: fixed;
  top: 0;
  width: 100%;
  margin: 0px -10px;
  right: 0px;
  z-index: 999;
  border-bottom: 2px solid #f7f9fa;
  /deep/.van-icon-volume-o {
    margin-left: 15px;
  }
}
.custom-button {
  width: 66px;
  color: #fff;
  font-size: 10px;
  line-height: 20px;
  text-align: center;
  background-color: #4187f2;
  border-radius: 100px;
}
.top-title {
  background: #3040f5;
  background-image: linear-gradient(to right, #3040f5, #4187f2);
  margin: 22px -20px 0 -20px;
  padding: 20px 0;
  font-size: 18px;
  font-weight: 500;
  color: #ffffff;
  line-height: 25px;
}
.info-top {
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
  margin-top: 10px;
  position: relative;
  z-index: 0;
  background: #4187f2;
  background-image: linear-gradient(to right, #3040f5, #4187f2);
  margin: 0 -10px -30px -10px;
  padding: 15px 15px 60px 15px;
  border-top: 1px solid #fff;
  li {
    width: 50%;
    span {
      font-size: 15px;
      color: #fff;
    }
    .tishi {
      font-size: 14px;
      font-weight: bold;
    }
  }
}
.form-wrap {
  margin: -66px -20px 20px -20px;
  position: relative;
  z-index: 1;
  .form-wrap-li {
    margin: 20px;
    background: #fff;
    padding: 10px;
    border-radius: 15px;
    box-shadow: 0px 0px 6px 0px rgba(4, 4, 4, 0.1);
    h6 {
      font-size: 16px;
      font-weight: 600;
      color: #333;
      line-height: 18px;
      margin: 10px 0;
    }
    .form-content-wrap {
      .form-content-li {
        margin-bottom: 20px;
        span {
          padding-bottom: 40px;
          font-size: 15px;
          font-weight: 400;
          color: #333;
          line-height: 21px;
        }
        .van-slider {
          height: 2px;
          margin-top: 20px;
          width: 84%;
          /* text-align: center; */
          margin-left: 30px;
        }
      }
    }
  }
}
.point-wrap {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  width: 100%;
  /deep/.point-li {
    width: 50%;
    line-height: 5px;
    // span{
    //   font-size: 20px;
    // }
  }
}
.all-point {
  font-weight: bold;
  color: #333;
  span {
    font-weight: normal;
    font-size: 22px;
  }
}
.warning {
  color: red;
  margin: 0 0 10px 0;
  font-size: 14px;
}
.van-radio-group--horizontal {
  /deep/.van-radio__label {
    font-size: 16px;
  }
  display: flex;
  justify-content: space-between;
  margin-top: 10px;
}
.van-radio-group .select {
  margin-bottom: 10px;
}
.submit-btn-wrap {
  text-align: center;
  // display: flex;
  // justify-content: space-between;
}
.mianshiguan {
  color: #333;
  display: flex;
  justify-content: space-between;
  p {
    margin: 10px 0;
    font-size: 16px;
  }
}
.my-swipe .van-swipe-item {
  color: #fff;
  font-size: 16px;
  text-align: left;
  p {
    margin: 10px;
    white-space: normal;
    word-wrap: break-word;
    word-break: break-all;
  }
}
.custom-indicator {
  display: flex;
  align-items: center;
  gap: 10px;
  position: absolute;
  right: 5px;
  bottom: 5px;
  pointer-events: none; // 点击穿透，避免妨碍 swipeitem 点击

  .custom-indicator-text {
    display: flex;
    align-items: center;
    gap: 5px;
    font-size: 14px;

    &.custom-indicator-text-edit {
      color: #4187f2 !important;
    }
  }
  .custom-indicator-index {
    padding: 2px 5px;
    font-size: 14px;
    border-radius: 5px;
    background: rgba(0, 0, 0, 0.1);
  }
}
.load-wrap {
  position: relative;
  z-index: 99999;
}
#evaluationSignPad {
  width: 320px;
  height: 200px;
  background: #dcdcdf;
}
.resign-btn-wrap {
  padding: 0 10px;
  text-align: center;
  margin-top: 10px;
  padding-bottom: 5px;
}
</style>
